import { useSelector } from "react-redux";

const useConfig = () => {

    const config = useSelector(state => state.config.data) || {};

    const labels = config.labels || {};
    const terminology = config.terminology || {};
    const brand = config.brand || {};
    const auth = config.auth || {};
    const flags = config.flags || {};
    const features = config.features || {};
    const charts = config.charts || {};
    const layout = config.layout || {};
    const files = config.files || {};
    const theme = config.theme || {};
    const links = config.links || {};
    const payload = config.payload || {};
    const dccColors = theme.dcc || {};
    const sentences = config.sentences || {};
    const dccSentences = sentences.dcc_sentences || {};
    const apiNodes = config.api || {};

    return {
        ...config,
        ...labels,
        ...terminology,
        ...brand,
        ...auth,
        ...flags,
        ...features,
        ...charts,
        ...layout,
        ...files,
        ...theme,
        ...links,
        ...payload,
        ...dccColors,
        ...sentences,
        ...apiNodes,
        ...dccSentences,
    };
};

export default useConfig;